
const GlobalDirectives = {
  /* install(Vue) {
    Vue.directive("click-outside", vClickOutside);
  } */
};

export default GlobalDirectives;